export const RECEIVE_PHONE_NUMBER = 'RECEIVE_PHONE_NUMBER';

export const receivePhoneNumber = (mobile: string) => ({
  type: RECEIVE_PHONE_NUMBER,
  payload: mobile,
});
